import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MultiStepSubmissionForm } from '../components/MultiStepSubmissionForm';
import { useFirebase } from '../lib/firebase/FirebaseProvider';

const SubmitReportPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useFirebase();

  // Redirect to home if not authenticated
  React.useEffect(() => {
    if (!user) {
      navigate('/');
    }
  }, [user, navigate]);

  const handleSuccess = (reportId: string) => {
    console.log('Report submitted successfully:', reportId);
    
    // Navigate to the specific report page with success message
    navigate(`/reports/${reportId}`, { 
      state: { 
        justSubmitted: true,
        message: 'Your treasure report has been submitted successfully!' 
      }
    });
  };

  const handleCancel = () => {
    navigate('/');
  };

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-urban mb-4">Authentication Required</h2>
          <p className="text-urban-300">Please log in to submit a report.</p>
        </div>
      </div>
    );
  }

  return (
    <MultiStepSubmissionForm
      onSuccess={handleSuccess}
      onCancel={handleCancel}
    />
  );
};

export default SubmitReportPage;